import { h } from 'preact';
import Store from 'store/store';

import * as jsonPointer from 'utils/jsonPointer';
import { joinClasses } from 'utils/utils';
import { getIcon } from 'utils/icons';

import EditorContent from 'components/editor/content';
import LandingPageEditor from 'components/editor/movies/landing';
import ShowtimesPageEditor from 'components/editor/movies/showtimes';
import HomeEntPageEditor from 'components/editor/movies/homeEnt';
import Button from 'components/button/button';

import s from 'components/editor/movies/moviePage.sss';

// Match with utils/editor (should this be in there instead?)
const pages = {
	home: LandingPageEditor,
	showtimes: ShowtimesPageEditor,
	'home-ent': HomeEntPageEditor,
};

let showStyleWarning = true;

export default class MoviePageEditor extends EditorContent {
	constructor(props) {
		super(props);

		// Initialize pages data with dummy data if it doesn't exist
		const moviePath = `${this.props.dataRoot}/content`;
		const movieData = jsonPointer.get(Store.get().data, moviePath);

		// Only initialize if pages structure doesn't exist
		// NOTE: ideally instead of forcing data to exist, each component should handle a lack of data (or any unexpected data) gracefully using reasonable defaults
		if (!movieData?.pages) {
			jsonPointer.setDeep(Store.get().data, moviePath, {
				...movieData,
				pages: {
					home: {
						active: true,
						socials: {
							facebook: { enabled: true, destination: 'https://facebook.com/', order: 1 },
							instagram: { enabled: true, destination: 'https://instagram.com/', order: 2 },
							tiktok: { enabled: true, destination: 'https://tiktok.com/', order: 3 },
							twitter: { enabled: true, destination: 'https://twitter.com/', order: 4 },
							youtube: { enabled: true, destination: 'https://youtube.com/', order: 5 },
						},
						settings: { default: true },
					},
					synopsis: {
						active: false,
						credits: {},
					},
					gallery: {
						active: false,
						images: {},
					},
					videos: {
						active: false,
						videos: {},
					},
					showtimes: {
						active: false,
					},
					homeEnt: {
						active: false,
					}
				},
			});
		}


		this.closeStyleWarning = this.closeStyleWarning.bind(this);
	}

	shouldShowStyleWarning() {
		const domains = Store.get().domains;
		if (domains.isFocus) {
			return false;
		}
		return showStyleWarning;
	}

	closeStyleWarning() {
		showStyleWarning = false;
		this.forceUpdate();
	}

	renderSubComponent() {
		const pagePath = this.props.path?.[3];
		const Component = pages[pagePath];
		if (Component) {
			return <Component {...this.props} />;
		}
		// return <div class={s.error}>Page not found</div>;
	}

	renderVisual() {
		return (
			<div class={s.visual}>
				<div class={joinClasses(s.styleWarning, this.shouldShowStyleWarning() && s.visible)}>
					<span class={s.text}>
						Editor styling may vary from the live site. Always check the <em>{getIcon('share')} Preview</em> to see the final design.
					</span>
					<Button dark icon="cancel" iconSize="small" class={s.close} onClick={this.closeStyleWarning} />
				</div>
				<div class={s.visualContent}>
					{this.renderSubComponent()}
				</div>
			</div>
		);
	}

	renderSettings() {
		return this.renderSubComponent();
	}
}
